import { useMutation } from '@tanstack/react-query';
import { resendInvite, resendTenantInvite } from '@/api/promote';

export function useResendInvite(accountId: string, tenantId?: string) {
  return useMutation({
    mutationFn: (userId?: string) =>
      tenantId ? resendTenantInvite(accountId, tenantId, userId) : resendInvite(accountId, userId),
  });
}
